import React from "react";
import PropTypes from "prop-types";
import { Label } from "../../Components/Label";
import { OptionWrapper } from "../../Components/OptionWrapper";
import { Utilities } from "@learningblocks/exp-constants";
import { NotebookImage } from "@learningblocks/simulations/shared-components";

const { COMPONENT_TYPE } = Utilities;

/**
 * Option:
 *  - Option Component for SingleSelect Component
 */
export function Option(props) {
  const selectOption = () => {
    props.disabled === false &&
      props.selectOption({
        optionID: props.id,
        checked: true,
      });
  };
  const getOptionClassName = () => {
    let className = "isq__option";
    if (props.disabled) className += " disabled";
    return className;
  };

  const renderNotebookImage = () => (
    <NotebookImage {...{ image: props.image }} key={props.id} />
  );

  const renderLabel = () => <Label label={props.text} id={props.id} />;

  const renderOptionContent = ({ type }) => {
    switch (type) {
      case COMPONENT_TYPE.NOTEBOOK_IMAGE:
        return renderNotebookImage();
      default:
        return renderLabel();
    }
  };

  return (
    <>
      <OptionWrapper
        className={getOptionClassName()}
        selectOption={selectOption}
        disabled={props.disabled}
      >
        {renderOptionContent(props)}
      </OptionWrapper>
    </>
  );
}

Option.propTypes = {
  /**
   * Custom className to be set on component
   */
  className: PropTypes.string,
  /**
   * ID for the particular prop
   */
  id: PropTypes.number.isRequired,
  /**
   * Boolean value specifying if the option is disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function to be involked when selecting the option
   */
  selectOption: PropTypes.func.isRequired,
  /**
   * Text for label
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.string,
};
